<script lang="ts">
  import { getDialog } from '$lib/dialogs';
  import { writable } from 'svelte/store';
  import Alert from '../Alert.svelte';
  import Spinner from '../Spinner.svelte';
  import { session } from '$lib/stores';
  import { invalidateAll } from '$app/navigation';
  import { startAuthentication } from '@simplewebauthn/browser';
  import { flipper } from '$lib/utils';

  type TSinginData = { email?: string; password?: string };

  const dialog = getDialog();
  const isLoading = writable(false);
  const showError = writable(false);
  const singinData = writable<TSinginData>({});
  const showPasswordField = writable(!flipper('webauthn'));

  const openForgotPassword = () => dialog.set('forgot-password');

  $: {
    if ($session) {
      dialog.set(null);
    }
  }

  const loginHandler = async (
    e: Event & {
      readonly submitter: HTMLElement | null;
    } & {
      currentTarget: EventTarget & HTMLFormElement;
    }
  ) => {
    $showError = false;
    try {
      const body = Object.fromEntries(new FormData(e.currentTarget));

      const res = await fetch('/ingresar', {
        method: 'POST',
        body: JSON.stringify(body)
      });

      const data = await res.json();

      console.log('Login response:', data);
      if (body.password && body.email) {
        if (res.ok) {
          invalidateAll();
        } else {
          $showError = true;
        }
        return;
      } else if (body.email) {
        if (flipper('webauthn')) {
          $singinData = body;
          const res = await checkPasskey();
          if (res?.verified) {
            invalidateAll();
            $dialog = null;
          } else if (res?.error) {
            $showError = true;
          } else {
            $showPasswordField = true;
          }
          return;
        } else {
          $showPasswordField = true;
        }
      }

      // invalidateAll();

      // console.log('Login response:', data);

      // if ($session?.uid) {
      //   $dialog = null;
      // } else if (data.status == 200) {
      //   $singinData = body;
      // } else {
      //   if (data.status == 200) {
      //     invalidateAll();
      //     $dialog = null;
      //   } else {
      //     $showError = true;
      //   }
      // }
    } catch (error) {
      console.error(error);
      $showError = true;
    } finally {
      $isLoading = false;
    }
  };

  const checkPasskey = async (e?: Event & { currentTarget: HTMLInputElement }) => {
    const email = e ? e.currentTarget.value : $singinData.email;
    if (!email) return;

    try {
      const res = await fetch(`/api/session/passkey/auth/options?email=${email}`);
      if (!res.ok) return;

      const options = await res.json();
      const attRes = await startAuthentication(options);
      const verificationRes = await fetch(`/api/session/passkey/auth/verify?email=${email}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(attRes)
      });
      const json = await verificationRes.json();
      return json;
    } catch (error) {
      if (
        (error as any).constructor.name === 'WebAuthnError' &&
        (error as any).cause?.name === 'NotAllowedError'
      ) {
        // User cancelled the passkey prompt
        return { verified: false };
      }
      console.error('Error checking passkey:', typeof error, error);
      return { verified: false, error };
    }
  };
</script>

<form on:submit|preventDefault={loginHandler}>
  <div>
    <h3 class="mb-6 text-center text-3xl font-extrabold text-primary-500" id="modal-title">
      Acceder
    </h3>
    {#if $showError}
      <Alert severity="danger">Usuario o contraseña incorrectos</Alert>
    {/if}
    <div class="space-y-6">
      <div>
        <label for="email" class="block text-sm font-medium text-gray-700">
          Correo electrónico
        </label>
        <div class="mt-1">
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            disabled={$isLoading}
            class="
                appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400
                focus:outline-none focus:ring-primary-500 focus:border-transparent focus:ring-2 sm:text-sm
              "
          />
        </div>
      </div>

      {#if $showPasswordField}
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700"> Contraseña </label>
          <div class="mt-1">
            <input
              id="password"
              name="password"
              type="password"
              required
              disabled={$isLoading}
              on:blur={() => document.querySelector('form')?.requestSubmit()}
              class="
              appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400
              focus:outline-none focus:ring-primary-500 focus:border-transparent focus:ring-2 sm:text-sm
            "
            />
          </div>
        </div>
      {/if}

      <button
        type="submit"
        class="
          w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm
          font-medium text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2
          focus:ring-primary-500
        "
        disabled={$isLoading}
      >
        {#if $isLoading}
          <Spinner />
        {/if}
        Acceder
      </button>

      <div class="flex items-center justify-center">
        <div class="text-sm">
          <a
            href="/olvidaste-tu-contrasena"
            on:click|preventDefault={openForgotPassword}
            class="w-full flex justify-center font-medium text-gray-600 hover:text-gray-500"
          >
            ¿Olvidaste tu contraseña?
          </a>
        </div>
      </div>
    </div>
  </div>
</form>
